import { MenuItem, Select, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useFormContext, Controller } from 'react-hook-form';
import { LuClock } from 'react-icons/lu';
import { ControlledTextInput, WsColors } from 'wisestep-base';

import WsAccordion from './WsAccordion';

const TotalExperienceFilter = () => {
  const { control, watch } = useFormContext();
  const experienceComparisonOperator = watch('experienceComparisonOperator');

  return (
    <WsAccordion
      title="Experience in Years"
      infoText="Search candidates using experience filter"
      startIcon={<LuClock color={WsColors.TertiaryShades800} />}
    >
      <Box sx={{ maxWidth: '55%' }}>
        <Stack direction="row" spacing={2}>
          <Controller
            render={({ field: { onChange, value = 'isBetween' } }) => (
              <Select
                sx={{ height: '47px', minWidth: '131px' }}
                inputProps={{ 'aria-label': 'Without label' }}
                onChange={onChange}
                value={value}
              >
                {['isEqual', 'isBetween'].map((option: string, index: number) => (
                  <MenuItem key={index} value={option}>
                    {option === 'isBetween' ? 'is Between' : 'is'}
                  </MenuItem>
                ))}
              </Select>
            )}
            control={control}
            name="experienceComparisonOperator"
          />
          <ControlledTextInput
            name="totalYearsExperienceStartRange"
            fullWidth
            type="number"
            id="candidate_experience_1"
            sx={{ minWidth: '39%' }}
            placeholder={experienceComparisonOperator === 'isEqual' ? 'Enter experience' : 'from'}
            variant="outlined"
            autoComplete="totalYearsExperienceStartRange"
          />
          {experienceComparisonOperator == 'isBetween' && (
            <ControlledTextInput
              name="totalYearsExperienceEndRange"
              type="number"
              fullWidth
              id="candidate_experience_2"
              sx={{ minWidth: '39%' }}
              placeholder="to"
              variant="outlined"
              autoComplete="totalYearsExperienceEndRange"
            />
          )}
        </Stack>
      </Box>
    </WsAccordion>
  );
};

export default TotalExperienceFilter;
